module.exports = __webpack_public_path__ + "img/album05_06.127260b2.jpg";